import { InteractiveMapMarker } from '../markers/map-marker';

export class MapMarkerClusterer extends InteractiveMapMarker {
  clusterMarkerId: string;
}
